module.exports = __webpack_public_path__ + "img/56.5c91aabe.jpg";